import React, { useCallback } from 'react'
import { JSONFetcher, ModalWithTrigger } from 'shared'
import { OrgaPermissionControlProps, Permissions } from './types'

export const OrgaPermissionControl = ({ permissionJson }: OrgaPermissionControlProps): JSX.Element => {
  const data: Permissions = JSON.parse(permissionJson)
  const disabled = !!(data.orgaPublicFace || data.projectPublicFace.length)

  const handleDelete: React.MouseEventHandler<HTMLButtonElement> = useCallback(
    (_event) => {
      if (window.confirm(i18n.t('manage.organisations.permissions.index.control.confirm_delete'))) {
        JSONFetcher.delete({
          url: data.resourceUrl,
          success: (_data) => window.location.reload(),
        })
      }
    },
    [data.resourceUrl]
  )

  return (
    <>
      <div className="grid desktop:grid-cols-3">
        <div className="desktop:col-span-2">
          <p className="m-0">
            <a href={data.userUrl}>{data.userName}</a>
          </p>
          {disabled && (
            <p className="mt-1 mb-0">
              <span>{i18n.t('manage.organisations.permissions.index.control.public_face_intro')}</span>{' '}
              <span>
                {data.orgaPublicFace &&
                  i18n.t('manage.organisations.permissions.index.control.public_face_organisation')}
              </span>
              <span>{data.orgaPublicFace && !!data.projectPublicFace.length ? ', ' : ' '}</span>
              {!!data.projectPublicFace.length && (
                <ModalWithTrigger
                  id="orga-permission-control"
                  content={`<ul>${data.projectPublicFace.map((title) => `<li>${title}</li>`).join('')}</ul>`}
                  trigger={i18n.t('manage.organisations.permissions.index.control.public_face_projects', {
                    count: data.projectPublicFace.length,
                  })}
                  title={`${i18n.t('manage.organisations.permissions.index.control.public_face_intro')} ${
                    data.userName
                  }`}
                />
              )}
            </p>
          )}
        </div>
        <div className="grid grid-cols-3 relative space-x-3 items-center" style={{ minWidth: '30%' }}>
          {!disabled && (
            <>
              <button
                className="simulated-link text-gray-900 hover:text-red-700 font-normal p-0 flex items-center"
                onClick={handleDelete}
              >
                <i className="fa fa-trash-alt fa-xs mr-1"></i>
                <span>{i18n.t('manage.organisations.permissions.index.control.delete_button')}</span>
              </button>
            </>
          )}
          {disabled && (
            <p className="mb-0 col-span-3 text-xs text-muted">
              {i18n.t(`manage.organisations.permissions.index.disabled_hint`)}
            </p>
          )}
        </div>
      </div>
    </>
  )
}
